import type { NodeData, NodePositions, NodeRecord } from '@ipfabric/utils';
import type {
  HydratedCollapsedNodeGroup,
  HydratedCollapsedNodeGroups,
} from 'components/Graph/model/GraphData';
import { record } from 'fp-ts';

export const getCollapsedNodePositions = (
  collapsedNodeGroups: HydratedCollapsedNodeGroups,
  nodes: NodeRecord,
): NodePositions =>
  record.reduce<HydratedCollapsedNodeGroup, NodePositions>(
    {},
    (positions: NodePositions, group) => {
      const currentPosition = nodes[group.id]?.position ?? { x: 0, y: 0 };

      const getNextNodePosition = (node: NodeData) => ({
        x: node.position.x + currentPosition.x - group.originalPosition.x,
        y: node.position.y + currentPosition.y - group.originalPosition.y,
      });

      for (const nodeData of Object.values(group.nodes)) {
        positions[nodeData.sn] = getNextNodePosition(nodeData);
      }

      return positions;
    },
  )(collapsedNodeGroups);
